import React, { useContext, useState, useEffect } from 'react';
import styled from '@emotion/styled';
import colors, { StyledForm, Success, Cancel } from './../../components/300/UiComponent';
import { Form, useFormik } from 'formik';
import { css } from '@emotion/react';
import * as yup from 'yup';
import api from '../../api/authApi';
import ImportStaff from '../300/course/ImportModal';
import CircularProgress from '@mui/material/CircularProgress';
import CustomizedSnackbars from '../300/curriculum/CustomizedSnackbars';

//context provider
import PositionContext from '../../context/PositionContext';

import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  Select,
  Avatar,
  FormHelperText,
  Grid,
} from '@mui/material';
import { FormatLineSpacing } from '@mui/icons-material';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from './../../hooks/useAxiosPrivate';

import useAuth from '../../hooks/useAuth';
import ProfileContext from '../../context/ProfileContext';
import StaffManagementContext from '../../context/StaffManagementContext';

import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from '../../components/300/styles';
// Here the drop down menu

const validationSchema = yup.object({
  title: yup.string('Enter Position Title').required('Position title is required'),
  position_load: yup.number('Enter position load ').required('Position load is required'),
  staff_id: yup.string('Select Staff').required('Staff is required'),
});

function EditPosition() {
  let location = useLocation();
  let navigate = useNavigate();
  const api = useAxiosPrivate();
  const { user, changed } = useAuth();

  const positionContext = useContext(PositionContext);
  const profileContext = useContext(ProfileContext);
  const staffContext = useContext(StaffManagementContext);
  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: '',
    type: '',
  });

  //const [selectedStaff, setSelectedStaff] = useState({});
  //let position = positionContext.positionState.filter((elem) => {
  //  return elem.id == location.state.id;
  //})[0];

  useEffect(() => {
    api
      .get('staff/staffs')
      .then((staffs) => {
        console.log(JSON.stringify(staffs.data, null, 2));
        staffContext.dispatch({
          type: 'loadStaff',
          staffs: staffs.data.staffs,
        });
      })
      .catch((err) => console.log(err));
    //let selectedStaff = staffContext.state.filter((elem) => {
    //  return elem.position.id == position?.id;
    //})[0];
  }, []);

  const formik = useFormik({
    initialValues: {
      title: location.state?.title,
      position_load: location.state?.position_load,
      staff_id: location.state.staff_id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let newValues = {
        ...values,
        id: location.state.id,
        old_staff: location.state.staff_id,
      };
      alert(JSON.stringify(newValues, null, 2));
      setAdding(true);
      api
        .patch('/position/updatePosition', newValues)
        .then((res) => {
          setAdding(false);
          navigate('../', {
            state: {
              message: { message: 'Updated Successfully', type: 'success' },
              open: true,
            },
          });
        })
        .catch((err) => {
          console.log(err);
          setAdding(false);
          setSnackBarOpen(true);
          setMessage({ message: err.response.data.message, type: 'error' });
        });
    },
  });

  return (
    <StyledForm onSubmit={formik.handleSubmit}>
      <Box sx={header}>
        <Typography
          variant="span"
          sx={{
            fontSize: '1.14rem',
            fontWeight: '600',
            lineHeight: '23.2px',
            color: 'primary.main',
          }}
        >
          Edit Position
        </Typography>
      </Box>
      <Grid container sx={formGroupContainer}>
        <Grid item lg={3.8} md={6} xs={12} sx={{ ...row, padding: '20px 0px' }}>
          <FormControl sx={groupStyled}>
            <FormLabel sx={labelStyled}>Title</FormLabel>
            <TextField
              id="title"
              name="title"
              value={formik.values.title}
              onChange={(e) => {
                setSnackBarOpen(false);
                formik.handleChange(e);
              }}
              error={formik.errors.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
              fullWidth
            />
          </FormControl>
        </Grid>
        <Grid item lg={3.8} md={6} xs={12} sx={{ ...row, padding: '20px 0px' }}>
          <FormControl sx={groupStyled}>
            <FormLabel htmlFor="position_load" sx={labelStyled}>
              Load
            </FormLabel>
            <TextField
              id="position_load"
              name="position_load"
              onChange={formik.handleChange}
              error={formik.touched.position_load && Boolean(formik.errors.position_load)}
              type="number"
              value={formik.values.position_load}
              helperText={formik.touched.position_load && formik.errors.position_load}
            />
          </FormControl>
        </Grid>

        <Grid item lg={3.8} md={6} xs={12} sx={{ ...row, padding: '20px 0px' }}>
          <FormControl sx={groupStyled}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <FormLabel htmlFor="staff_id" sx={labelStyled}>
                Staff
              </FormLabel>
              <Select
                id="staff_id"
                name="staff_id"
                value={formik.values.staff_id}
                onChange={(e) => {
                  console.log(e);
                  formik.handleChange(e);
                }}
                error={formik.errors.staff_id && Boolean(formik.errors.staff_id)}
                input={<OutlinedInput name="staff_id" id="select-multiple-chip" />}
                fullWidth
              >
                {staffContext?.state
                  ?.filter((staff) => {
                    console.log(
                      profileContext?.state?.host +
                        staff?.pic?.slice(1) +
                        `?token=${user?.accessToken}`
                    );
                    return staff.reg_status == 'Active';
                  })
                  .map((staff) => {
                    debugger;
                    console.log(staff);
                    return (
                      <MenuItem
                        key={staff.id}
                        value={staff.id}
                        disabled={Boolean(staff.position.id)}
                      >
                        <Box
                          sx={{
                            padding: '0rem',
                            display: 'flex',
                            gap: '1rem',
                            alignItems: 'center',
                          }}
                        >
                          <Avatar
                            src={
                              profileContext?.state?.host +
                              staff?.pic?.slice(1) +
                              `?token=${user?.accessToken}`
                            }
                          >
                            {staff && staff.first_name && staff.first_name[0]}
                            {staff && staff.middle_name && staff.middle_name[0]}
                          </Avatar>
                          {staff.first_name + ' ' + staff.last_name}
                        </Box>
                      </MenuItem>
                    );
                  })}
              </Select>
            </Box>

            <FormHelperText sx={{ color: '#c02424' }}>
              {formik.errors.staff_id &&
                formik.touched.staff_id &&
                `Staff is
                required`}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      {snackBarOpen && <CustomizedSnackbars {...{ setSnackBarOpen, snackBarOpen, message }} />}

      <Box
        sx={{
          display: 'flex',
          gap: '1.8rem',
          justifyContent: 'flex-end',
          width: '100%',
        }}
      >
        <NavLink to={'../'} style={{ textDecoration: 'none' }}>
          <Button variant="outlined" color="third">
            Cancel
          </Button>
        </NavLink>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'secondary.main',
            '&:hover': {
              backgroundColor: 'secondary.hover',
            },
          }}
          type="submit"
        >
          Upadate
        </Button>
      </Box>
    </StyledForm>
  );
}

export default EditPosition;
